import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Level, LevelsData} from "@core/services/backend/common/interface/levels";
import {LevelsApi} from "@core/services/backend/common/api/levels.api";

@Injectable()
export class LevelsService extends LevelsData {
    constructor(private api: LevelsApi) {
        super();
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        return this.api.list(search, pageNumber, pageSize, orderBy);
    }

    get(id: number): Observable<Level> {
        return this.api.get(id);
    }

    getByLevel(level: number): Observable<Level[]> {
        return this.api.getByLevel(level);
    }

    create(level: any): Observable<Level> {
        return this.api.add(level);
    }

    update(level: any): Observable<Level> {
        return this.api.update(level);
    }

    delete(level: any): Observable<Level> {
        return this.api.delete(level);
    }
}

